module.exports = {
      id: "twitter-square-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-0c0ef6e463acc47e64bde7ab1fdd2b32.svg#twitter-square",
      toString: function () {
        return this.url;
      }
    }